import { Component, OnInit } from '@angular/core';
import { Route, ActivatedRoute, Params, Router } from '@angular/router';
import { WorkflowApprovalService, WorkflowTaskService, ReportService } from '../../camtl/camtl.service';
import { CgpSnackbarService } from '../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpConfirmationDialogService } from '../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';

import { BaseService } from '../../mesc/mesc.service';
import { ProjectService, SystemService, CamtlBaseService, RequestProcessService, ConstructionSourceService, IntegrationSourceService } from '../camtl.service';
import { cgpAuthentication } from '../../../../modules/cgp-authentication';
import { AuthenticationService } from '../../../../app/auth.service';
import { BehaviorSubject } from 'rxjs';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { S3Service } from '../../../shared/s3.service';
import { FileInfo, FileState } from '@progress/kendo-angular-upload';

@Component({
  selector: 'app-approval',
  templateUrl: './approval.component.html',
  styleUrls: ['./approval.component.scss'],
  host: { 'class': 'router-outlet' },
})
export class ApprovalComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private routeParams: ActivatedRoute,
    private workflowApprovalService: WorkflowApprovalService,
    private workflowTaskService: WorkflowTaskService,
    private cgpAlertDialogService: CgpAlertDialogService,
    private cgpSnackbarService: CgpSnackbarService,
    public baseService: BaseService,
    private projectService: ProjectService,
    private systemService: SystemService,
    private authService: AuthenticationService,
    private cgpConfirmationDialogService: CgpConfirmationDialogService,
    private contactListService: CamtlBaseService,
    private requestProcessService: RequestProcessService,
    private constructionSourceService: ConstructionSourceService,
    private integrationSourceService: IntegrationSourceService,
    private reportService: ReportService,
    private readonly s3Service: S3Service,
    private readonly router: Router
  ) { }


  constructionState: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  integrationState: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  contactState: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  projectState: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  formTitle: BehaviorSubject<string> = new BehaviorSubject<string>('');
  stepText: BehaviorSubject<string> = new BehaviorSubject<string>('');
  systemId: any;
  system: any;
  selectedProject: any;
  isRejected: boolean = false;
  isApproved: boolean = false;
  showSubmitDialog: boolean = false;
  isApproval: boolean = true;
  showFloorSpace: boolean = false;
  isApprover: boolean;
  isAdmin: boolean;
  approvalState: number;
  contacts: Contact[];
  selectedSystem: any;
  selectedConstructionSource: any;
  selectedIntegrationSource: any;

  steps: any[] = [
    {
      title: "MFD",
      status: false,
      rejected: false,
      active: false,
    },
    {
      title: "EGM",
      status: false,
      rejected: false,
      active: false,
    },
    {
      title: "MFD",
      status: false,
      rejected: false,
      active: false,
    },
    {
      title: "FIN",
      status: false,
      rejected: false,
      active: false,
    },
    {
      title: "ALLO",
      status: false,
      rejected: false,
      active: false,
    },
  ]

  editForm: FormGroup = this.formBuilder.group({});


  ngOnInit() {
    var self = this;
    this.routeParams.params
      .subscribe((params: Params) => {
        this.systemId = this.routeParams.snapshot.params["systemId"];
        self.readInfo();
      })

    this.projectService.subscribe(x => this.projectState.next(x));
  }


  ngOnChanges() {
    var self = this;
    if (this.routeParams.snapshot.params["systemId"]) {
      this.systemId = this.routeParams.snapshot.params["systemId"];
      self.readInfo();
    }
  }


  readInfo() {
    var self = this;
    self.isAdmin = self.authService.isClaimValid("/MESC/CAMTL/Administration");
    self.workflowApprovalService.read("/" + self.systemId, true)
      .then(function (response) {
        try {
          self.system = response;
          if (response) {
            if (response.SystemSurroundSetup || response.FullIntegration || response.HomeLine) {
              self.showFloorSpace = true;
            }
            if (response.AssignedToEmail === cgpAuthentication.getUserInfo().mail) {
              self.isApprover = true;
            }

            self.systemService.read("/" + self.system.SystemId, true)
              .then(function (response) {
                self.selectedSystem = response;
                self.updateState();
                self.updateContactInfo();
                self.updateEditForm();
                self.updateStepText();
                self.updateStepper();
              })
              .catch(e => this.handleError(e));
          }

          // self.system = response ? response : {}; // REMOVE
          self.toggleViews(self.system.Result);

        } catch (e) { }
      })
      .catch(e => this.handleError(e));

  }


  updateState() {
    try {
      this.approvalState = parseInt(this.system.StepName.split(' ')[1]);
    } catch (e) {
      // this.approvalState = 4; // REMOVE - MOCK DATA
      // this.contactState.next([
      //   "test1@gm.com",
      //   "test2@gm.com",
      //   "test3@gm.com",
      //   "test4@gm.com",
      // ])
    }
  }


  updateStepText() {
    let response = this.system;
    let stepText: string = response.StepName;
    if (response.Result === 'Rejected') {
      stepText = "System " + response.SystemNumber + " has been rejected. Resubmit for approval."
    }
    this.stepText.next(stepText);
  }


  updateStepper() {
    if (this.system) {
      let tasks: any[] = this.system.WFTasks;
      let step: number;
      tasks.map(x => {
        step = parseInt(x.StepName.split(' ')[1]) - 1;
        this.steps[step].status = x.Status === 'Approved';
        this.steps[step].rejected = x.Status === 'Rejected';
      })

      // Current Task
      let task = tasks.find(x => x.Id === this.system.WFTaskId);
      if (task) {
        try {
          let stepName: string = task.StepName;
          step = parseInt(task.StepName.split(' ')[1]) - 1;
          this.steps[step].active = true;
        } catch (e) { }
      }
    }
  }


  getStepTitle(step: any): string {
    return step.status ?
      step.title + ' Approved' :
      step.active ?
        'Current Location' :
        step.rejected ?
          step.title + ' Rejected'
          : '';
  }


  toggleViews(result) {
    if (result === null || result === undefined) {
      this.isApproved = false;
      this.isRejected = false;
    }
    else if (result === "Approved") {
      this.isApproved = true;
      this.isRejected = false;
    }
    else {
      this.isApproved = false;
      this.isRejected = true;
    }
  }


  onClose = () => {
    this.showSubmitDialog = false;
    setTimeout(() => {
      this.workflowTaskService.loading.next(true);
      this.router.navigate(['/MESC/CAMTL/WorkflowInbox']);
    }, 1000);
  }


  submitEditForm = () => {
    let form: any = this.editForm.value;
    if (form && this.editForm.valid) {
      var updateDto = {
        SystemId: this.selectedSystem.Id,
        ProjectId: this.selectedProject ? this.selectedProject : null,
        ConstructionSourceId: this.selectedConstructionSource ? this.selectedConstructionSource : null,
        IntegrationSourceId: this.selectedIntegrationSource ? this.selectedIntegrationSource : null,
        ConstructionWorkOrderNumber: this.editForm.value.ConstWorkOrder ? this.editForm.value.ConstWorkOrder : null,
        IntegrationWorkOrderNumber: this.editForm.value.IntegWorkOrder ? this.editForm.value.IntegWorkOrder : null,
      }

      this.requestProcessService.save(updateDto, false, "", false, false, false).then(function (response) {

      })
        .catch(function (response) {
          this.handleError(response);
        })
    }
  }


  showDialog = (e, isApproved) => {
    var self = this;
    if (!isApproved) {
      this.showSubmitDialog = true;
      return;
    }

    var approvalDto = {
      Status: 'Approved'
    }

    this.cgpConfirmationDialogService.showConfirmationDialog({
      title: 'Approve System',
      message: 'Are you sure that you want to approve this task?',
      alert: 'danger',
      onYesClick: () => {
        self.workflowTaskService.loading.next(true);
        this.workflowTaskService
          .save(approvalDto, false, "?id=" + this.system.WFTaskId, false, false, false)
          .then(function (response) {
            self.cgpConfirmationDialogService.closeConfirmationDialog();
            if (self.approvalState !== 1) {
              self.submitEditForm();
            }
            self.cgpAlertDialogService.showAlertDialog({
              title: 'Approved',
              message: 'Task has been approved. You will be redirected to your inbox',
              alert: 'success',
              closeLabel: 'OK',
              onClosed: self.onClose
            })
          })
          .catch(e => this.handleError(e));
      },
      onNoClick: () => {
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      }
    })

  }


  closeForm() {
    this.showSubmitDialog = false;
  }


  onCancel(e) {
    e.preventDefault();
    this.closeForm();
  }


  onSaveApproval(e, comments) {
    var self = this;
    var approvalDto = {
      Status: "Rejected",
      Response: comments
    }

    if (!comments || comments.trim() === "") {
      this.cgpAlertDialogService.showAlertDialog({
        title: 'Error',
        message: 'You must enter comments for a rejected system',
        alert: 'danger',
        closeLabel: 'OK'
      })
      return;
    }
    self.workflowTaskService.loading.next(true);
    this.workflowTaskService
      .save(approvalDto, false, "?id=" + this.system.WFTaskId, false, false, false).then(function (response) {
        self.showSubmitDialog = false;
        self.cgpAlertDialogService.showAlertDialog({
          title: 'Rejected',
          message: 'Task has been rejected. You will be redirected to your inbox',
          alert: 'danger',
          closeLabel: 'OK',
          onClosed: self.onClose
        })
      }).catch(function (response) {
        self.showSubmitDialog = false;
        this.handleError(response);
      });
  }


  handleProjectFilter = (e: string) => {
    let newState = this.projectService.value.filter(x => x.Description.toLowerCase().indexOf(e.toLowerCase()) === 0);
    this.projectState.next(newState);
  }


  handleProjectChange = (e: any) => {
    this.selectedProject = e;
  }

  handleConstSourceChange = (e: any) => {
    this.selectedConstructionSource = e;
  }

  handleIntegSourceChange = (e: any) => {
    this.selectedIntegrationSource = e;
  }

  /**
   * Populate contact fields using data from the request dto
   */
  updateContactInfo() {
    let sys = this.system;
    let requestor = <Contact>{
      header: 'Requested By',
      title: sys.Requestor,
      name: sys.RequestorName,
      phone: sys.RequestorPhone,
      email: sys.RequestorEmail,
    },
      comingFrom = <Contact>{
        header: 'Coming From',
        title: sys.ComingFrom,
        name: sys.ComingFromName,
        phone: sys.ComingFromPhone,
        email: sys.ComingFromEmail,
      },
      goingTo = <Contact>{
        header: 'To Be Approved By',
        title: sys.GoingTo,
        name: sys.GoingToName,
        phone: sys.GoingToPhone,
        email: sys.GoingToEmail,
      },
      assignedTo = <Contact>{
        header: 'Send To',
        title: '',
        name: sys.AssignedToName,
        phone: sys.AssignedToPhone,
        email: sys.AssignedToEmail,
      }
    this.contacts = [requestor, comingFrom, assignedTo, goingTo];
  }


  /**
   * 
   */
  updateEditForm() {
    let title: string;
    let formGroup: any = {};
    var self = this;
    switch (this.approvalState) {
      case 1:
        title = 'MFD Approval Form';
        break;
      case 2:
        title = 'EGM Approval Form';
        this.projectService.read("?$filter=Active eq true", true);
        formGroup = {
          ProjectId: [this.selectedSystem.ProjectId, Validators.required],
        };
        this.handleProjectChange(this.selectedSystem.ProjectId);
        break;
      case 3:
        title = 'WTC Request Process Approval Form';
        this.constructionSourceService.query();
        this.integrationSourceService.query();
        formGroup = {
          ConstructionSourceId: ['', Validators.required],
          IntegrationSourceId: ['', Validators.required],
        }
        break;
      case 4:
        title = 'Financial Approval Form';
        formGroup = {
          ConstWorkOrder: ['', Validators.required],
          IntegWorkOrder: ['', Validators.required],
        }
        break;
      case 5:
        this.contactListService.read("/ContactList?systemId=" + this.selectedSystem.Id + "&programId=" + this.selectedSystem.ProgramId + "&projectId=" + this.selectedSystem.ProjectId, true)
          .then(function (response) {
            response.map(x => x.EmailDescription = x.EmailAddress + ' ' + x.Description);
            self.contactState.next(response);
            self.contactState["data"] = self.contactState["_value"];
          })
        title = 'Final Request Process Report';
        formGroup = {
          ContactId: [[], Validators.required],
        }
        break;
      default:
        break;
    }

    this.editForm = this.formBuilder.group(formGroup);
    if (this.approvalState == 5) this.editForm.reset({ ContactId: this.contactState.value });
    this.formTitle.next(title);
  }


  handleEmail = (isReject: boolean = false) => {
    var contacts = this.editForm.value.ContactId.map(contact => contact.EmailAddress).join();
    var self = this;
    var approvalDto = {
      Status: 'Submitted',
      Response: contacts
    }
    if (isReject) {
      this.cgpConfirmationDialogService.showConfirmationDialog({
        title: 'Reject Approval Report',
        message: 'Are you sure that you want to reject?',
        alert: 'warning',
        onYesClick: () => {
          approvalDto.Response = "";
          this.workflowTaskService.loading.next(true);
          this.workflowTaskService
            .save(approvalDto, false, "?id=" + this.system.WFTaskId, false, false, false)
            .then(function (response) {
              self.cgpConfirmationDialogService.closeConfirmationDialog();
              self.cgpAlertDialogService.showAlertDialog({
                title: 'Rejected',
                message: 'Approval Report has been rejected. You will be redirected to your inbox',
                alert: 'success',
                closeLabel: 'OK',
                onClosed: self.onClose
              })
            })
            .catch(e => this.handleError(e));
        },
        onNoClick: () => {
          this.cgpConfirmationDialogService.closeConfirmationDialog();
        }
      })
    } else {

      this.cgpConfirmationDialogService.showConfirmationDialog({
        title: 'Send Approval Report',
        message: 'Are you sure that you want to email the selected recipients?',
        alert: 'success',
        onYesClick: () => {
          this.workflowTaskService.loading.next(true);
          this.workflowTaskService
            .save(approvalDto, false, "?id=" + this.system.WFTaskId, false, false, false)
            .then(function (response) {
              self.cgpConfirmationDialogService.closeConfirmationDialog();
              self.cgpAlertDialogService.showAlertDialog({
                title: 'Email sent',
                message: 'Emails have been sent to recipients. You will be redirected to your inbox',
                alert: 'success',
                closeLabel: 'OK',
                onClosed: self.onClose
              })
            })
            .catch(e => this.handleError(e));

        },
        onNoClick: () => {
          this.cgpConfirmationDialogService.closeConfirmationDialog();
        }
      })
    }
  }

  controls: any[] = [
    {
      type: "combobox",
      name: "ProjectId",
      title: "Project",
      placeholder: "Select a Project...",
      textField: "Description",
      valueField: "Id",
      service: this.projectState,
      onChange: this.handleProjectChange
    },
    {
      type: "combobox",
      name: "ConstructionSourceId",
      title: "Construction Source",
      placeholder: "Select a Construction Source...",
      textField: "Name",
      valueField: "Id",
      service: this.constructionSourceService,
      onChange: this.handleConstSourceChange
    },
    {
      type: "combobox",
      name: "IntegrationSourceId",
      title: "Integration Source",
      placeholder: "Select an Integration Source...",
      textField: "Name",
      valueField: "Id",
      service: this.integrationSourceService,
      onChange: this.handleIntegSourceChange
    },
    {
      type: "text",
      name: "ConstWorkOrder",
      title: "Const. Work Order #",
      maxlength: 40,
    },
    {
      type: "text",
      name: "IntegWorkOrder",
      title: "Intg. Work Order #",
      maxlength: 40,
    },
    {
      type: "multiselect",
      name: "ContactId",
      title: "Send To:",
      placeholder: "Select report recipients...",
      textField: 'EmailDescription',
      valueField: 'EmailAddress',
      sync: true,
      service: this.contactState,
    },
  ]

  generateReport() {
    let report = {
      ReportName: this.selectedSystem.SystemNumber + "_R" + this.selectedSystem.ToolListRevision + ".pdf",
      RequestId: ""
    }
    if (report) {
      const path = `/generate/${this.selectedSystem.Id}/${this.selectedSystem.ToolListRevision}`;
      this.reportService.download(path, {})
        .then(x => this.downloadReport(report, x))
        .catch(e => this.handleError(e));
    }
  }

  downloadReport(report: any, response: any) {
    const body = response.json();
    const blob = new Blob([body], { type: 'application/pdf' });
    this.s3UploadReport(report, blob);

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = report.ReportName;
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  s3UploadReport(report: any, blob: Blob): Promise<any> {
    const _path = `CAMTLREPORTS/${report.ReportName}`;
    const formData = new FormData();
    formData.append('attachment', blob);
    return this.s3Service.uploadS3ByteArray(formData, _path);
  }

  handleError = (e) => {
    this.showSubmitDialog = false;
    this.cgpAlertDialogService.showAlertDialog({
      title: e.status + ' Error',
      message: e._body ? e._body.replace(/["{}]/g, '').replace(/message:/i, "") : '',
      alert: 'danger',
      closeLabel: 'Close',
    })
  }
}

class Contact {
  header: string;
  title: string;
  name: string;
  phone: string;
  email: string;
}
